import axios, {AxiosResponse, AxiosError} from "axios";
import { Buffer } from "buffer";

import { BASE_URL } from "../Config";


interface Credentials {
    email: string;
    password: string;
}

function getHeaders(token: string | undefined) {
    if(token == "" || token == null) {
        return {
            "Content-Type": "application/json"
        }
    }
    
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    }
}

export const loginUser = (credentials: Credentials) => {
    return axios(`${BASE_URL}/auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: credentials,
    })
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response
       }
       return null;
    });
};


export const getAcademy = (token: string) => {
    return axios(`${BASE_URL}/academy`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}

export const getAcademyCategory = (token: string, category: string | undefined) => {
    return axios(`${BASE_URL}/academy/${category}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}

export const getAcademyStats = (token: string) => {
    return axios(`${BASE_URL}/academy/stats`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}

export const getMissions = (token: string) => {
    return axios(`${BASE_URL}/missions`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}


export const getChallenge = (token: string, challenge_id: string | undefined) => {
    return axios(`${BASE_URL}/challenge/${challenge_id}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}

export const downloadChallenge = (token: string, challenge_id: string | undefined) => {
    return axios(`${BASE_URL}/challenge/${challenge_id}/download`, {
        method: "GET",
        headers: getHeaders(token),
        responseType: 'arraybuffer'
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) {
            const fileData = Buffer.from(response.data, 'binary');
            return fileData;
        }
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}


export const executeChallenge = (token: string, action: string, challenge_id: string|undefined, exploit: string) => {
    const data = {
        exploit: exploit,
        action: action
    };
    return axios(`${BASE_URL}/challenge/${challenge_id}`, {
        method: "POST",
        headers: getHeaders(token),
        data: data
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response
        }
        return null
    });
}


export const getChallenges = (token: string) => {
    return axios(`${BASE_URL}/challenges`, {
        method: "GET",
        headers: getHeaders(token),
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        return error.response;
    });
}


export const getLastSolved = (token: string) => {
    return axios(`${BASE_URL}/challenges/last_solved`, {
        method: "GET",
        headers: getHeaders(token),
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}


export const getRecentChallenges = (token: string, limit: number) => {
    return axios(`${BASE_URL}/challenges?order=desc&limit=${limit}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}


export const getLeaderboard = async (token: string) => {
    return axios(`${BASE_URL}/leaderboard`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}


export const getUserData = (token: string) => {
    return axios(`${BASE_URL}/userdata`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}

/** The dashboard calendar and learning streak; null on failure. */
export const getUserActivity = (token: string) => {
    return axios(`${BASE_URL}/user/activity`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => response.data)
    .catch(() => null);
};

export const getUserStats = (token: string) => {
    return axios(`${BASE_URL}/user/stats`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response;
        }
        return null;
    });
}

export const getProfileStats = (username: string) => {
    return axios(`${BASE_URL}/profile/${username}`, {
        method: "GET"
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        return error.response;
    });
}

interface Passwords {
    old_password: string;
    new_password: string;
    confirm_new_password: string;
}

export const changePassword = (token: string, passwords: Passwords) => {
    return axios(`${BASE_URL}/change_password`, {
        method: "POST",
        headers: getHeaders(token),
        data: passwords
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        throw error; 
    });
}


export const logout = (token: string) => {
    return axios(`${BASE_URL}/logout`, {
        method: "POST",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    })
}


// Revokes every access token for the account, this one included, by bumping the
// user's token epoch server-side. Unlike /logout it is a database change, so it
// holds across API workers and restarts.
export const logoutAll = (token: string) => {
    return axios(`${BASE_URL}/logout-all`, {
        method: "POST",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    })
}


export const confirmUser = (token: string | undefined) => {
    return axios(`${BASE_URL}/confirm/${token}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
}


interface RegisterData {
    username: string;
    email: string;
    password: string;
    confirm_password: string;
    recaptcha_token: string;
    accept_terms: boolean;
    // Separate from accept_terms on purpose: consent to marketing may not be
    // bundled into acceptance of the Terms.
    marketing_consent: boolean;
    // First-touch signup source, see utils/attribution.ts.
    attribution?: {
        referrer: string | null;
        utm_source: string | null;
        utm_medium: string | null;
        utm_campaign: string | null;
        landing_path: string | null;
    };
}
export const registerUser = (register_data: RegisterData) => {
    return axios(`${BASE_URL}/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        data: register_data
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        return error.response;
    });
}

interface ForgotPasswordData {
    email: string;
    recaptcha_token: string;
}
export const forgotPassword = (forgotPasswordData: ForgotPasswordData) => {
    return axios(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        data: forgotPasswordData 
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};


export const resetPasswordTokenCheck = (token: string | undefined) => {
    return axios(`${BASE_URL}/reset-password/${token}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: Error | AxiosError) => {
        return null;
    });
   
}

interface ResetPasswordData {
    new_password: string;
    confirm_new_password: string;
}
export const resetPassword = (token: string | undefined, resetPasswordData: ResetPasswordData) => {
    return axios(`${BASE_URL}/reset-password/${token}`, {
        method: "POST",
        headers: getHeaders(token),
        data: resetPasswordData
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
}

export const deleteUser = (token: string) => {
    return axios(`${BASE_URL}/user/delete`, {
        method: "DELETE",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};


export const adminGetChallenges = (token: string) => {
    return axios(`${BASE_URL}/admin/challenges`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((AxiosError) => {
        return null;
    });
};


export const adminGetChallenge = (token: string, challenge_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/challenge/${challenge_id}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};


interface Challenge {
    name: string;
    app: string;
    active: boolean;
    difficulty: number;
    points: number;
    type: number;
    category: string;
    docker_image: string;
}
export const adminUpdateChallenge = (token: string, challenge_id: string | undefined, challenge: Challenge) => {
    return axios(`${BASE_URL}/admin/challenge/${challenge_id}`, {
        method: "PUT",
            headers: getHeaders(token),
            data: challenge,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                // The body, to match the success branch above: both callers read
                // `msg` off this, so returning the raw response would swallow
                // the validation message (e.g. a rejected category or app).
                return error.response.data
            }
            return null;
        });
};


export const adminDeleteChallenge = (token: string, challenge_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/challenge/${challenge_id}`, {
        method: "DELETE",
            headers: getHeaders(token)
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};


export const adminAddChallenge = (token: string, challenge: Challenge) => {
    return axios(`${BASE_URL}/admin/challenges`, {
        method: "POST",
            headers: getHeaders(token),
            data: challenge,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                // The body, to match the success branch above: both callers read
                // `msg` off this, so returning the raw response would swallow
                // the validation message (e.g. a rejected category or app).
                return error.response.data
            }
            return null;
        });
};


export const getTheoryStages = (token: string, category: string | undefined) => {
    return axios(`${BASE_URL}/academy/${category}/theory`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}

export const getTheoryStageQuestions = (token: string, category: string | undefined, stageSlug: string | undefined) => {
    return axios(`${BASE_URL}/academy/${category}/theory/${stageSlug}/questions`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        return response;
    })
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response;
        }
        return null;
    });
}

export const submitTheoryAnswer = (token: string, category: string | undefined, stageSlug: string | undefined, questionId: string, choice: string) => {
    return axios(`${BASE_URL}/academy/${category}/theory/${stageSlug}/questions/${questionId}/answer`, {
        method: "POST",
        headers: getHeaders(token),
        data: { choice }
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
}


interface TheoryStage {
    category: string;
    slug: string;
    title: string;
    order_index: number;
    points: number;
    active: boolean;
}

export const adminGetTheoryStages = (token: string) => {
    return axios(`${BASE_URL}/admin/theory/stages`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((AxiosError) => {
        return null;
    });
};

export const adminGetTheoryStage = (token: string, stage_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/theory/stage/${stage_id}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminAddTheoryStage = (token: string, stage: TheoryStage) => {
    return axios(`${BASE_URL}/admin/theory/stages`, {
        method: "POST",
            headers: getHeaders(token),
            data: stage,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};

export const adminUpdateTheoryStage = (token: string, stage_id: string | undefined, stage: TheoryStage) => {
    return axios(`${BASE_URL}/admin/theory/stage/${stage_id}`, {
        method: "PUT",
            headers: getHeaders(token),
            data: stage,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};

export const adminDeleteTheoryStage = (token: string, stage_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/theory/stage/${stage_id}`, {
        method: "DELETE",
            headers: getHeaders(token)
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};


interface TheoryQuestion {
    order_index: number;
    question: string;
    choice_a: string;
    choice_b: string;
    choice_c: string;
    choice_d: string;
    correct_choice: string;
    explanation: string;
}

export const adminGetTheoryQuestions = (token: string, stage_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/theory/stage/${stage_id}/questions`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((AxiosError) => {
        return null;
    });
};

export const adminGetTheoryQuestion = (token: string, question_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/theory/question/${question_id}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminAddTheoryQuestion = (token: string, stage_id: string | undefined, question: TheoryQuestion) => {
    return axios(`${BASE_URL}/admin/theory/stage/${stage_id}/questions`, {
        method: "POST",
            headers: getHeaders(token),
            data: question,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};

export const adminUpdateTheoryQuestion = (token: string, question_id: string | undefined, question: TheoryQuestion) => {
    return axios(`${BASE_URL}/admin/theory/question/${question_id}`, {
        method: "PUT",
            headers: getHeaders(token),
            data: question,
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};

export const adminDeleteTheoryQuestion = (token: string, question_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/theory/question/${question_id}`, {
        method: "DELETE",
            headers: getHeaders(token)
        })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => {
            if (error.response) {
                return error.response
            }
            return null;
        });
};


export const adminGetUsers = (token: string) => {
    return axios(`${BASE_URL}/admin/users`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((AxiosError) => {
        return null;
    });
};


// --- Marketing email preferences ---

export const getEmailPreferences = (token: string) => {
    return axios(`${BASE_URL}/user/email-preferences`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const updateEmailPreferences = (token: string, marketing_consent: boolean, source?: string) => {
    return axios(`${BASE_URL}/user/email-preferences`, {
        method: "PUT",
        headers: getHeaders(token),
        data: { marketing_consent, source }
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

// Unauthenticated by design: unsubscribing must never require a login.
export const getUnsubscribeInfo = (unsubscribe_token: string | undefined) => {
    return axios(`${BASE_URL}/unsubscribe/${unsubscribe_token}`, {
        method: "GET",
        headers: getHeaders("")
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const unsubscribeByToken = (unsubscribe_token: string | undefined) => {
    return axios(`${BASE_URL}/unsubscribe/${unsubscribe_token}`, {
        method: "POST",
        headers: getHeaders("")
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};


// --- Admin: user intel ---
// Shapes are declared in components/Admin/Intel/types.ts. `includeAdmins`
// counts admin accounts too; the API leaves them out by default.

const adminIntelGet = (token: string, path: string, params: Record<string, unknown> = {}) => {
    return axios(`${BASE_URL}/admin/intel/${path}`, {
        method: "GET",
        headers: getHeaders(token),
        params,
    })
    .then((response: AxiosResponse) => response.data)
    .catch(() => null);
};

export const adminGetIntelOverview = (token: string, days: number, includeAdmins = false) =>
    adminIntelGet(token, "overview", { days, include_admins: includeAdmins });

export const adminGetIntelContent = (token: string, includeAdmins = false) =>
    adminIntelGet(token, "content", { include_admins: includeAdmins });

export const adminGetIntelUsers = (token: string, includeAdmins = false) =>
    adminIntelGet(token, "users", { include_admins: includeAdmins });

export const adminGetIntelUser = (token: string, userId: string | undefined) =>
    adminIntelGet(token, `user/${userId}`);

// --- Admin: marketing campaigns ---

export interface CampaignDraft {
    subject: string;
    preheader: string;
    body_markdown: string;
}

export const adminGetCampaigns = (token: string) => {
    return axios(`${BASE_URL}/admin/emails/campaigns`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminAddCampaign = (token: string, campaign: CampaignDraft) => {
    return axios(`${BASE_URL}/admin/emails/campaigns`, {
        method: "POST",
        headers: getHeaders(token),
        data: campaign
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminGetCampaign = (token: string, campaign_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminUpdateCampaign = (token: string, campaign_id: string | undefined, campaign: CampaignDraft) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}`, {
        method: "PUT",
        headers: getHeaders(token),
        data: campaign
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminDeleteCampaign = (token: string, campaign_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}`, {
        method: "DELETE",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminPreviewCampaign = (token: string, campaign_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}/preview`, {
        method: "POST",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminTestCampaign = (token: string, campaign_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}/test`, {
        method: "POST",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

// `confirm_recipient_count` is echoed back from what the admin was shown; the
// API refuses the send if the audience moved in the meantime.
export const adminSendCampaign = (token: string, campaign_id: string | undefined, confirm_recipient_count: number) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}/send`, {
        method: "POST",
        headers: getHeaders(token),
        data: { confirm_recipient_count }
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminCancelCampaign = (token: string, campaign_id: string | undefined) => {
    return axios(`${BASE_URL}/admin/emails/campaign/${campaign_id}/cancel`, {
        method: "POST",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminGetSuppressions = (token: string) => {
    return axios(`${BASE_URL}/admin/emails/suppressions`, {
        method: "GET",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => {
        if(response.status == 200) return response.data;
        return null;
    })
    .catch((error: AxiosError) => {
        return null;
    });
};

export const adminAddSuppression = (token: string, email: string, reason: string, note?: string) => {
    return axios(`${BASE_URL}/admin/emails/suppressions`, {
        method: "POST",
        headers: getHeaders(token),
        data: { email, reason, note }
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};

export const adminDeleteSuppression = (token: string, suppression_id: string) => {
    return axios(`${BASE_URL}/admin/emails/suppression/${suppression_id}`, {
        method: "DELETE",
        headers: getHeaders(token)
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
        if (error.response) {
            return error.response.data
        }
        return null;
    });
};


// --- Public tech-stack quizzes (practice, no points, no auth required) ---

interface TechQuizAttemptStart {
    total_questions: number;
}

interface TechQuizAttemptResult {
    score: number;
    score_easy: number;
    score_medium: number;
    score_hard: number;
    duration_seconds: number;
    timed_out: boolean;
}

// Best-effort telemetry: every call is null-safe so the quiz keeps working if the
// API is unreachable. `token` is optional, sent only when a logged-in user takes it.
export const startTechQuizAttempt = (slug: string, payload: TechQuizAttemptStart, token?: string): Promise<string | null> => {
    return axios(`${BASE_URL}/tech-quiz/${slug}/attempts`, {
        method: "POST",
        headers: getHeaders(token),
        data: payload,
    })
    .then((response: AxiosResponse) => {
        if (response.status === 201 || response.status === 200) return response.data?.attempt_id ?? null;
        return null;
    })
    .catch(() => null);
};

export interface TechQuizShare {
    share_id: string;
    /** Public link carrying the link-preview tags; it redirects browsers to the result page. */
    share_url: string;
    /** Shown on the shared page; null when the quiz was taken signed out. */
    username: string | null;
}

// Resolves to the result's share link, or null if the result could not be recorded.
export const finishTechQuizAttempt = (slug: string, attemptId: string, payload: TechQuizAttemptResult, token?: string): Promise<TechQuizShare | null> => {
    return axios(`${BASE_URL}/tech-quiz/${slug}/attempts/${attemptId}/finish`, {
        method: "POST",
        headers: getHeaders(token),
        data: payload,
    })
    .then((response: AxiosResponse) => {
        if (response.status !== 200 || !response.data?.share_id) return null;
        return {
            share_id: response.data.share_id,
            share_url: response.data.share_url,
            username: response.data.username ?? null,
        };
    })
    .catch(() => null);
};

export interface TechQuizResult {
    share_id: string;
    quiz_slug: string;
    quiz_title: string;
    /** Null when the quiz was taken signed out. */
    username: string | null;
    finished_at: string | null;
    timed_out: boolean;
    duration_seconds: number | null;
    score: number | null;
    score_easy: number | null;
    score_medium: number | null;
    score_hard: number | null;
    total_questions: number;
    share_url: string;
    result_url: string;
}

// Public: the result behind a share link. Null when it does not exist.
export const getTechQuizResult = (shareId: string): Promise<TechQuizResult | null> => {
    return axios(`${BASE_URL}/tech-quiz/results/${encodeURIComponent(shareId)}`, {
        method: "GET",
    })
    .then((response: AxiosResponse) => (response.status === 200 ? response.data : null))
    .catch(() => null);
};

export const adminGetTechQuizAttempts = (token: string, slug: string, page = 1, perPage = 50) => {
    return axios(`${BASE_URL}/admin/tech-quiz/attempts`, {
        method: "GET",
        headers: getHeaders(token),
        params: { quiz_slug: slug, page, per_page: perPage },
    })
    .then((response: AxiosResponse) => {
        if (response.status === 200) return response.data;
        return null;
    })
    .catch(() => null);
};
